import React, { FC } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';
import { Row, Col } from 'styled-bootstrap-grid';

import { Player } from '../../../../../database.schema';
import { MatchPlayer } from './match-player';

const DropWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 20rem;
`;

type TeamDropBoxProps = {
  team1Players: Array<Player>;
  team2Players: Array<Player>;
};

export const PairsDropBoxes: FC<TeamDropBoxProps> = ({ team1Players, team2Players }): JSX.Element => {
  return (
    <div>
      <div>
        <div key={`result-m1`}>
          <h3>{`Pairs Match 1`}</h3>
          <DropWrapper data-testid={`pairs-1-1`}>
            <MatchPlayer dndId={`team1Pair-1-0`} player={team1Players.length > -1 ? team1Players[0] : null} team="team1-0" bgColor="red" matchIndex={0} />
            <MatchPlayer dndId={`team2Pair-1-0`} player={team2Players.length > -1 ? team2Players[0] : null} team="team2-0" bgColor="blue" matchIndex={0} />
          </DropWrapper>
          <DropWrapper data-testid={`pairs-1-2`}>
            <MatchPlayer dndId={`team1Pair-2-0`} player={team1Players.length > 0 + 1 ? team1Players[1] : null} team="team1-2" bgColor="red" matchIndex={0} />
            <MatchPlayer dndId={`team2Pair-2-0`} player={team2Players.length > 0 + 1 ? team2Players[1] : null} team="team2-2" bgColor="blue" matchIndex={0} />
          </DropWrapper>
        </div>
        <div key={`result-m2`}>
          <h3>{`Pairs Match 2`}</h3>
          <DropWrapper data-testid={`pairs-2-1`}>
            <MatchPlayer dndId={`team1Pair-1-1`} player={team1Players.length > 1 ? team1Players[2] : null} team="team1-1" bgColor="red" matchIndex={1} />
            <MatchPlayer dndId={`team2Pair-1-1`} player={team2Players.length > 1 ? team2Players[2] : null} team="team2-1" bgColor="blue" matchIndex={1} />
          </DropWrapper>
          <DropWrapper data-testid={`pairs-2-2`}>
            <MatchPlayer dndId={`team1Pair-2-1`} player={team1Players.length > 2 ? team1Players[3] : null} team="team1-2" bgColor="red" matchIndex={1} />
            <MatchPlayer dndId={`team2Pair-2-1`} player={team2Players.length > 2 + 1 ? team2Players[3] : null} team="team2-2" bgColor="blue" matchIndex={1} />
          </DropWrapper>
        </div>
      </div>
    </div>
  );
};
